var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6881 14.4464C15.4238 14.6115 15.1266 14.6776 14.8623 14.6776C14.5981 14.6776 14.3008 14.6115 14.0366 14.4464L0.890381 6.41992V17.0888C0.890381 19.3679 2.74009 21.2176 5.01921 21.2176H24.7385C27.0176 21.2176 28.8673 19.3679 28.8673 17.0888V6.41992L15.6881 14.4464Z",
    fill: "#4A7FA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7385 0.607422H5.01922C3.07042 0.607422 1.41889 1.99471 1.02252 3.84442L14.8954 12.3003L28.7352 3.84442C28.3388 1.99471 26.6873 0.607422 24.7385 0.607422Z",
    fill: "#4A7FA7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.931692c9d5aefdce0281c82fc1c253c1.svg";
export { ForwardRef as ReactComponent };